// extracted by mini-css-extract-plugin
export default {"wrapper":"button_wrapper__PWPVq","button":"button_button__dMNQP","divider":"button_divider__T+G+6","line":"button_line__5WAjL","orText":"button_orText__3RxZ9"};